import { Modal } from '@tribeplatform/react-ui-kit/Modal'

import { VerifyForm } from './VerifyForm'

export const VerifyModal = ({ open, onClose }) => {
  return (
    <Modal open={open} onClose={onClose}>
      <Modal.Header title="Verify your account" />
      <Modal.Content>
        <VerifyForm />
      </Modal.Content>
    </Modal>
  )
}
